<template>
  <div class="pro_container">
    <!-- tableb表格 -->
    <div class="table-box table_container">
      <global-tag>
        <div class="search" slot="search">
          <el-form label-width="80px">
            <el-row>
              <el-col :span="5">
                <el-form-item label="用户类型:">
                  <el-select
                    style="width: 100%"
                    clearable
                    v-model="userType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in customerTypeList"
                      :key="item.dictCode"
                      :label="item.dictLabel"
                      :value="item.dictCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="套餐类型:">
                  <el-select
                    style="width: 100%"
                    v-model="ensure"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in seatTypeList"
                      :key="item.id"
                      :label="item.mealType"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="3" :offset="11">
                <el-button
                  style="float: right"
                  type="primary"
                  class="searchBtns"
                  @click="querySearch"
                  >搜索
                </el-button>
                <!--              <el-button type="info" icon="el-icon-delete" @click="emptySearch">清除条件</el-button>-->
              </el-col>
            </el-row>
          </el-form>
        </div>
      </global-tag>
      <div class="table_title">
        <div>
          <el-button
            type="success"
            icon="el-icon-plus"
            class="openBtns"
            size="small"
            @click="handleTableForm('新增')"
            >新增
          </el-button>
          <div style="display: none">
            <input
              @change="(e) => uploadInfo(e, '4')"
              id="speechUpload"
              type="file"
            />
          </div>
          <!-- <label for="speechUpload" class="labelImportBtn">
                    <span>导入</span>
                </label> -->
          <el-button
            type="primary"
            icon="el-icon-download"
            class="button button1 downOutBtns"
            @click="createExcel"
            >导出
          </el-button>
          <!-- <el-button type="danger" class="button" @click="mobandaochu"
                    >模板导出
                </el-button> -->
        </div>

        <!-- 筛选按钮 -->
        <!-- <div class="searchButtonDiveRight">
          <el-button-group>
            <el-button
              type="primary"
              icon="el-icon-refresh"
              class="dropRests"
              @click="Reset"
            ></el-button>
            <el-dropdown
              class="dropdown1"
              trigger="click"
              :hide-on-click="false"
            >
              <span class="el-dropdown-link">
                <i class="el-icon-s-grid el-icon--right"></i>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="table_checkbox">
                <el-dropdown-item>
                  <el-checkbox-group
                    v-model="tableChekbox"
                    @change="tableChekboxChange"
                  >
                    <el-checkbox label="序号"></el-checkbox>

                    <br />
                    <el-checkbox label="计划进度"></el-checkbox>
                    <br />
                    <el-checkbox label="服务名称"></el-checkbox>
                    <br />
                    <el-checkbox label="工单类型"></el-checkbox>
                    <br />
                    <el-checkbox label="用户类型"></el-checkbox>
                    <br />

                    <el-checkbox label="套餐类型"></el-checkbox>
                    <br />
                    <el-checkbox label="区域名称"></el-checkbox>
                    <br />

                    <el-checkbox label="计划时间"></el-checkbox>
                    <br />
                    <el-checkbox label="工单进度"></el-checkbox>
                    <br />
                    <el-checkbox label="操作"></el-checkbox>
                  </el-checkbox-group>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-button-group>
        </div> -->
      </div>
      <el-table
        :data="tableData"
        ref="tables"
        tooltip-effect="dark"
        style="width: 100%; margin-bottom: 15px"
        height="550px"
        :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          v-if="tempTableChekbox.findIndex((item) => item === '序号') !== -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          width="120"
          align="center"
          prop="endPlan"
          label="计划进度"
          v-if="
            tempTableChekbox.findIndex((item) => item === '计划进度') !== -1
          "
          :show-overflow-tooltip="false"
        >
          <template slot-scope="scope">
            <!-- {{ scope.row.endPlan }} -->
            <p class="endPlanBox">
              <img src="../../assets/img/orderIcon.png" alt="" srcset="" />
              <span class="endGreen" v-if="scope.row.endPlan >= 10">{{
                scope.row.endPlan
              }}</span>
              <span
                class="endOrange"
                v-else-if="scope.row.endPlan < 10 && scope.row.endPlan >= 5"
                >{{ scope.row.endPlan }}</span
              >
              <span
                class="endRed"
                v-else-if="scope.row.endPlan <= 4 && scope.row.endPlan > 0"
                >{{ scope.row.endPlan }}</span
              >
              <span v-else>结束</span>
            </p>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="pgdName"
          label="服务名称"
          v-if="
            tempTableChekbox.findIndex((item) => item === '服务名称') !== -1
          "
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="customerType"
          label="工单类型"
          v-if="
            tempTableChekbox.findIndex((item) => item === '工单类型') !== -1
          "
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.customerType == 7">商业服务工单</span>
            <span v-if="scope.row.customerType == 3">残联服务工单</span>
            <span v-if="scope.row.customerType == 4">老干服务工单</span>
            <span v-if="scope.row.customerType == 6">民政服务工单</span>
            <span v-if="scope.row.customerType == 10">文明办服务工单</span>
            <span v-if="scope.row.customerType == 14">退役军人服务工单</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="userType"
          label="用户类型"
          v-if="
            tempTableChekbox.findIndex((item) => item === '用户类型') !== -1
          "
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              v-for="(item, index) in customerTypeList"
              :key="index"
              v-if="scope.row.userType == item.dictCode"
              >{{ item.dictLabel }}</span
            >
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="ensureName"
          label="套餐类型"
          v-if="
            tempTableChekbox.findIndex((item) => item === '套餐类型') !== -1
          "
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="serviceAreaName"
          label="区域名称"
          v-if="
            tempTableChekbox.findIndex((item) => item === '区域名称') !== -1
          "
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- <el-table-column
                    align="center"
                    prop="servestationName"
                    label="机构"
                    v-if="
                        tempTableChekbox.findIndex(
                            (item) => item === '机构'
                        ) !== -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column> -->

        <el-table-column
          align="center"
          prop="palnTimeStart"
          label="计划开始时间"
          v-if="
            tempTableChekbox.findIndex((item) => item === '计划开始时间') !== -1
          "
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="palnTimeEnd "
          label="计划结束时间"
          v-if="
            tempTableChekbox.findIndex((item) => item === '计划结束时间') !== -1
          "
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="pgdSpeed "
          label="工单进度"
          v-if="
            tempTableChekbox.findIndex((item) => item === '工单进度') !== -1
          "
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ scope.row.pgdSpeed }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          prop="operation"
          label="操作"
          align="center"
          width="140px"
          v-if="tempTableChekbox.findIndex((item) => item === '操作') !== -1"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="查看"
              placement="top-start"
            >
              <img
                alt
                src="../assets/img/detail.png"
                style="cursor: pointer"
                @click="handleTableForm('查看', scope.row)"
              />
            </el-tooltip>
            <!-- <el-tooltip
                            class="item"
                            effect="dark"
                            content="删除"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/table_delete.png"
                                alt=""
                                @click="deleteItem(scope.row)"
                                style="margin-left: 12px; cursor: pointer"
                            />
                        </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :current-page.sync="pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handletableDataSize"
        @current-change="handleTableDataChange"
      ></el-pagination>
    </div>
    <!-- tbale 新增删除修改弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogVisibleTitle"
      :visible.sync="dialogVisible"
      width="1000px"
      class="dialog_container"
      @close="dialogVisibleClose"
    >
      <div class="dialog_content">
        <el-form
          label-width="100px"
          :model="formData"
          ref="formData"
          :rules="formDataRules"
        >
          <div
            v-if="dialogVisibleTitle !== '新增'"
            style="
              display: flex;
              justify-content: space-around;
              margin-bottom: 25px;
            "
          >
            <el-button
              @click="changeButtonType('工单预设服务')"
              :type="formButtonType === '工单预设服务' ? 'primary' : 'info'"
              >工单预设服务
            </el-button>
            <el-button
              @click="changeButtonType('服务工单')"
              :type="formButtonType === '服务工单' ? 'primary' : 'info'"
              >服务工单
            </el-button>
          </div>

          <div v-if="formButtonType === '工单预设服务'">
            <el-form-item label="服务名称:" prop="pgdName">
              <el-input
                :disabled="dialogVisibleTitle == '查看'"
                v-model.trim="formData.pgdName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="工单类型：" prop="customerType">
              <el-select
                :disabled="dialogVisibleTitle == '查看'"
                style="width: 100%"
                v-model="formData.customerType"
                placeholder="请选择"
                size="medium"
              >
                <el-option label="老干服务工单" value="4"></el-option>
                <el-option label="民政服务工单" value="6"></el-option>
                <el-option label="文明办服务工单" value="10"></el-option>
                <el-option label="残联服务工单" value="3"></el-option>
                <el-option label="商业服务工单" value="7"></el-option>
                <el-option label="退役军人服务工单" value="14"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户类型:" prop="userType">
              <el-select
                clearable
                @change="oldType"
                :disabled="dialogVisibleTitle == '查看'"
                style="width: 100%"
                v-model="formData.userType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in customerTypeList"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域名称:" prop="serviceAreaId">
              <!-- <el-select
                                :disabled="dialogVisibleTitle == '查看'"
                                v-model.trim="formData.serviceAreaId"
                                ref="areaName"
                                placeholder="请选择"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in quyuList"
                                    :key="item.orgId"
                                    :label="item.label"
                                    :value="item.orgId"
                                >
                                </el-option>
                            </el-select> -->
              <el-cascader
                ref="orgId"
                :key="isRescourceShow"
                :disabled="dialogVisibleTitle == '查看'"
                :show-all-levels="false"
                v-model="formData.serviceAreaId"
                style="width: 100%"
                :options="quyuList"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'label',
                  value: 'orgId',
                }"
                @change="changetype"
                clearable
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="套餐类型:" prop="ensure">
              <el-input
                disabled
                v-if="dialogVisibleTitle == '查看' && formData.ensureNames"
                v-model="formData.ensureNames"
              ></el-input>
              <el-select
                :disabled="dialogVisibleTitle == '查看'"
                v-else
                style="width: 100%"
                v-model="formData.ensure"
                @change="changeEnsure"
                placeholder="请选择"
              >
                <el-option
                  v-for="item of seatTypeList"
                  :key="item.id"
                  :label="item.mealType"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="机构:" prop="serveStation">
                            <el-select
                                v-model="formData.serveStation"
                                placeholder="请选择"
                                style="width: 100%"
                                ref="serveName"
                                :disabled="dialogVisibleTitle === '查看'"
                            >
                                <el-option
                                    v-for="item in serviceStationList"
                                    :key="item.selectTreeId"
                                    :label="item.statName"
                                    :value="item.selectTreeId"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item> -->

            <el-row>
              <el-col :span="11">
                <el-form-item label="计划时间:" prop="palnTimeStart">
                  <el-date-picker
                    :disabled="dialogVisibleTitle == '查看'"
                    style="width: 100%"
                    :picker-options="pickerOptionsStart"
                    v-model="formData.palnTimeStart"
                    @change="changeStart"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择开始时间"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="2"
                ><p style="line-height: 40px; text-align: center">至</p></el-col
              >
              <el-col :span="11">
                <el-form-item label-width="0" prop="palnTimeEnd">
                  <!-- :picker-options="pickerOptionsEnd" -->
                  <el-date-picker
                    disabled
                    style="width: 100%"
                    v-model="formData.palnTimeEnd"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择结束时间"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="月度工单:" prop="monthPgdCount">
              <el-input
                :disabled="dialogVisibleTitle == '查看'"
                type="number"
                v-model.trim="formData.monthPgdCount"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="间隔天数:" prop="intervalDays">
              <el-input
                :disabled="dialogVisibleTitle == '查看'"
                v-model.trim="formData.intervalDays"
                type="number"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div v-if="formButtonType === '服务工单'">
            <div class="service-order-list">
              <div class="service-order-item">
                <div class="service-order-num">
                  {{ numInfo.pgdTotal }}
                </div>
                <div class="service-order-title">工单总数</div>
              </div>
              <div class="service-order-item">
                <div class="service-order-num">
                  {{ numInfo.finishCount }}
                </div>
                <div class="service-order-title">已完成</div>
              </div>
              <div class="service-order-item">
                <div class="service-order-num">
                  {{ numInfo.noFinishCount }}
                </div>
                <div class="service-order-title">未完成</div>
              </div>
            </div>
            <work-order-progress
              v-if="dialogVisibleTitle != '新增'"
              :openData="formData.batch"
            />
          </div>
        </el-form>
        <div
          v-if="dialogVisibleTitle !== '查看'"
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 15px;
          "
        >
          <el-button type="primary" @click="save">确 定 </el-button>
          <el-button @click="dialogVisibleClose">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!--    工单进度弹框-->
    <!-- <el-dialog
            :close-on-click-modal="false"
            title="工单进度"
            :visible.sync="orderProgressVisible"
            width="1000px"
            @close="orderProgressClose"
            append-to-body
        >
            <work-order-progress
                :only-show-look="false"
                @handle="handleTableForm"
                ref="workOrderProgress2"
            />
        </el-dialog> -->
  </div>
</template>

<script>
import request from "@/utils/request.js"
import globalTag from "@/component/globalTag"
import headLine from "../../components/headline"
import common from "@/utils/common.js"
import baseURL from "@/api/baseURL"
import workOrderProgress from "../component/workOrderProgress"

export default {
  name: "proManage",

  data() {
    return {
      serveStation: "",
      userType: "",
      ensure: "",
      pickerOptionsStart: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.formData.palnTimeStart
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() + 29 * 24 * 60 * 60 * 1000
            )
          }
        },
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      quyuList: [],
      serviceStationList: [],
      // 服务种类列表
      serviceTypeList: [
        { label: "家政", value: "1" },
        { label: "政府援助", value: "2" },
        { label: "维修", value: "3" },
        { label: "搬家", value: "4" },
        { label: "代购 代办", value: "5" },
        { label: "医疗", value: "6" },
      ],
      seatTypeList: [],
      // 图片上传地址
      baseUrl: baseURL + "/jjyl/controller/uploadController/info/uploadPhoto",
      // 图片地址
      imageUrl: "",
      // 新增表单中的按钮切换
      formButtonType: "工单预设服务",
      // 搜索表单客户姓名
      customerName: "",
      // 搜索表单客户类型
      userType: "",
      projectName1: "",
      projectName: "",
      // 客户类型列表
      typeParameter: "",
      customerTypeList: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      isdisabled: false,
      orgList: [],
      orgLevels: "",
      pageSize: 10,
      total: 0,
      pageNo: 1,
      proName: "", //项目名称
      tableData: [],
      tempTableChekbox: [
        "序号",
        "计划进度",
        "服务名称",
        "工单类型",
        "用户类型",
        "套餐类型",
        "区域名称",
        "计划时间",
        "工单进度",
        "操作",
      ],
      tableChekbox: [
        "序号",
        "计划进度",
        "服务名称",
        "工单类型",
        "用户类型",
        "套餐类型",
        "区域名称",

        "计划时间",
        "工单进度",
        "操作",
      ],
      dialogVisible: false, //table表单弹窗
      showAddStatus: false,
      dialogVisibleTitle: "", //table表单弹窗title
      numInfo: {
        pgdTotal: 0,
        noFinishCount: 0,
        finishCount: 0,
      },
      formData: {
        ensure: "",
        price: 0,
        userType: "",
        customerType: "",
        serveStation: "",
        servestationName: "",
        palnTimeStart: "",
        serviceAreaId: "",
        serviceAreaName: "",
        palnTimeEnd: "",
        monthPgdCount: null,
        intervalDays: null,
      },
      saveLoad: false,
      chooseIds: [],
      saveIds: [],
      orderProgressVisible: false,
      isRescourceShow: 0,
      formDataRules: {
        pgdName: [
          {
            required: true,
            message: "服务名称不能为空",
            trigger: "blur",
          },
        ],
        customerType: [
          {
            required: true,
            message: "工单类型不能为空",
            trigger: "blur",
          },
        ],
        userType: [
          {
            required: true,
            message: "用户类型不能为空",
            trigger: "blur",
          },
        ],
        ensure: [
          {
            required: false,
            message: "套餐类型不能为空",
            trigger: "blur",
          },
        ],

        serviceAreaId: [
          {
            required: true,
            message: "区域名称不能为空",
            trigger: "blur",
          },
        ],
        monthPgdCount: [
          {
            required: true,
            message: "月工单量不能为空",
            trigger: "blur",
          },
        ],
        intervalDays: [
          {
            required: true,
            message: "间隔天数不能为空",
            trigger: "blur",
          },
        ],
        palnTimeStart: [
          {
            required: true,
            message: "开始时间不能为空",
            trigger: "blur",
          },
        ],
        palnTimeEnd: [
          {
            required: true,
            message: "结束时间不能为空",
            trigger: "blur",
          },
        ],
      },
    }
  },
  components: {
    globalTag,
    headLine,
    workOrderProgress,
  },
  mounted() {
    this.getTreeChecked()
  },
  watch: {
    quyuList() {
      ++this.isRescourceShow
      console.log(this.isRescourceShow)
    },
  },
  methods: {
    // 多选
    selectionChange(val) {
      const self = this
      if (val.length > 0) {
        val.forEach((item) => {
          self.saveIds.push(item.id)
        })
        self.saveIds = self.unique(self.saveIds)
      }
    },
    // 去重方法
    unique(arr) {
      return Array.from(new Set(arr))
    },
    // 时间切换
    mGetDate(year, month) {
      let d = new Date(year, month, 0)
      return d.getDate()
    },
    changeStart(val) {
      let nextTime = new Date(val).getTime()
      let nextDate = new Date(nextTime)
      let getFullYear = nextDate.getFullYear()
      let month = nextDate.getMonth()
      let getMonth =
        nextDate.getMonth() + 1 > 10
          ? nextDate.getMonth() + 1
          : "0" + (nextDate.getMonth() + 1)
      let getDay = this.mGetDate(getFullYear, month)
      this.formData.palnTimeEnd =
        getFullYear +
        "-" +
        getMonth +
        "-" +
        getDay +
        " " +
        "23" +
        ":" +
        "59" +
        ":" +
        "59"
      this.formData.palnTimeStart =
        getFullYear +
        "-" +
        getMonth +
        "-" +
        "01" +
        " " +
        "00" +
        ":" +
        "00" +
        ":" +
        "00"
      // console.log(this.formData.palnTimeEnd, "结束时间")
    },

    getTreeChecked() {
      this.$http
        .request({
          url: "/jjyl/admin/serviceStation/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              return
            }
            this.serviceStationList = res.content.list.map((item) => {
              return {
                selectTreeId: item.id, //id
                statName: item.statName,
              }
            })
          }
        })
    },
    async fileChange(event) {
      const file = event.target.files[0]
      const personType = "1"
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
      let formData = new FormData()
      formData.append("personType", personType)
      formData.append("file", file)
      let result = await this.$http.post(
        "/jjyl/servicePgd/info/ServicePgdExcel",
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById("speechUpload")
      fileEle.value = ""
      if (result.code === 200) {
        this.$message.success(result.message)
        this.getDataList()
      } else {
        this.$message.warning(result.message)
      }
    },
    mobandaochu() {
      this.request2({
        url: "/jjyl/servicePgd/info/Templatedownload",
        method: "POST",
        data: {
          userType: this.userType,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          ensure: this.ensure,
        },
        responseType: "blob",
      }).then((resp) => {
        if (resp) {
          const blob = new Blob([resp], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "模板导出.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出成功")
        }
      })
    },
    createExcel() {
      const self = this
      let parmar = {}
      if (this.saveIds.length > 0) {
        parmar = {
          ids: self.saveIds,
          userType: self.userType,
          ensure: self.ensure,
          serveStation: self.serveStation,
        }
      } else {
        parmar = {
          pageNo: 1,
          pageSize: -1,
          userType: self.userType,
          ensure: self.ensure,
          serveStation: self.serveStation,
        }
      }
      // console.log("导出参数", parmar)
      this.request2({
        url: "/jjyl/servicePgd/plan/info/download",
        method: "POST",
        excel: true,
        data: parmar,
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "服务计划.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)

          // self.showList()
          self.$refs.tables.clearSelection()
          self.saveIds = []
          this.$message.success("导出表格成功")
        }
      })
    },
    // 获取价格
    changeEnsure(val) {
      this.seatTypeList.forEach((item) => {
        if (item.id == val) {
          this.formData.price = item.price
        }
      })
    },
    // 获取套餐类型
    getMeat() {
      request({
        url: "/jjyl/admin/meal/info/findList",
        method: "POST",
        data: {
          states: 1,
          pageNo: 1,
          pageSize: 1000,
          dataId: this.formData.serviceAreaId,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.seatTypeList = []
          if (res.content) {
            this.seatTypeList = res.content.list
          } else {
            this.seatTypeList = []
          }
        }
      })
    },

    // 关闭工单进度弹框
    orderProgressClose() {
      this.orderProgressVisible = false
    },
    // 显示工单进度弹框
    showOrderProgress() {
      this.orderProgressVisible = true
    },
    // 新增表单中的按钮切换
    changeButtonType(value) {
      this.formButtonType = value
      if (value == "服务工单") {
        this.getNums()
      }
    },
    // 服务工单
    getNums() {
      request({
        url: "/jjyl/servicePgd/plan/info/countPlanPgd",
        method: "POST",
        data: { batch: this.formData.batch },
      }).then((res) => {
        if (res.code == 200) {
          // console.log(res.content, "服务工单数")
          this.numInfo = {
            pgdTotal: res.content.pgdTotal == null ? 0 : res.content.pgdTotal,
            noFinishCount:
              res.content.noFinishCount == null ? 0 : res.content.noFinishCount,
            finishCount:
              res.content.finishCount == null ? 0 : res.content.finishCount,
          }
        }
      })
    },
    loopNode(node, arr) {
      if (node.parent == null) {
        return arr
      } else {
        arr.push(node.data.orgId)
        this.loopNode(node.parent, arr)
      }
    },

    //获取组织机构
    getOrg() {
      // this.$http
      //     .request({
      //         url: "/rbac/admin/org/info/OrgTreelist",
      //         method: "POST",
      //         data: { isValid: 1 },
      //     })
      //     .then((res) => {
      //         if (res.code == 200) {
      //             const arr = []
      //             this.loopTree(res.content, arr)
      //             let orgId =
      //                 this.dialogVisibleTitle == "新增"
      //                     ? this.$store.state.info.orgId
      //                     : this.formData.serviceAreaId
      //             // console.log(arr,'结果')
      //             this.quyuList = arr.filter((item) => {
      //                 // console.log(item.orgId == this.$store.state.info.orgId,item,'结果')
      //                 return item.orgId == orgId
      //             })
      //             this.$forceUpdate()
      //         }
      //     })
      this.$post("/rbac/admin/org/info/OrgTreelist", { isValid: 1 }).then(
        (res) => {
          if (res.code === 200) {
            //当前账号绑定的机构所有下级
            let treeList = []
            this.quyuList = this.chbehavior(
              res.content,
              this.$store.state.info.orgId
            )
            let orgLevel = this.getorgLevel(
              res.content,
              this.$store.state.info.orgId
            )
            if (!this.quyuList.children) {
              //this.quyuList = [];//当前账号绑定的机构没有下级时就置空
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
              })
              this.quyuList = treeList //带同级本身的数据
            } else {
              //this.quyuList = this.quyuList.children;// 不带本身同级，只取下级
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
                children: this.quyuList.children,
              })
              this.quyuList = treeList //带同级本身的数据
            }
          }
        }
      )
    },
    changetype() {
      this.seatTypeList = []
      this.formData.ensure = ""
      this.getMeat()
    },
    //递归获取当前机构数据
    chbehavior(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },

    //获取当前机构等级
    getorgLevel(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a.orgLevel
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },
    getChildrenId(arr) {
      let res = []
      ;(function deepId(arr) {
        for (let i = 0; i < arr.length; i++) {
          res.push(arr[i].orgId)
          if (arr[i].children) {
            deepId(arr[i].children)
          }
        }
      })(arr)
      return res
    },
    //回显(多级)
    changeDetSelect(value, key, treeData) {
      let arr = [] // 在递归时操作的数组
      let returnArr = [] // 存放结果的数组
      let depth = 0 // 定义全局层级
      // 定义递归函数
      function childrenEach(childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN // 将执行的层级赋值 到 全局层级
          arr[depthN] = childrenData[j][key]
          if (childrenData[j][key] == value) {
            returnArr = arr.slice(0, depthN + 1) //将目前匹配的数组，截断并保存到结果数组，
            break
          } else {
            if (childrenData[j].children) {
              depth++
              childrenEach(childrenData[j].children, depth)
            }
          }
        }
        return returnArr
      }
      return childrenEach(treeData, depth)
    },
    // 树转同级
    loopTree(data, arr) {
      data.forEach((item) => {
        arr.push(item)
        if (Array.isArray(item.children)) {
          this.loopTree(item.children, arr)
        }
      })
    },

    // 分页切换
    handletableDataSize(val) {
      this.pageSize = val
      this.showList()
    },
    // 分页切换
    handleTableDataChange(val) {
      this.pageNo = val
      this.showList()
    },
    //table列checkbox发生变化
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item)
    },
    //处理table表格表单
    handleTableForm(title, row) {
      this.dialogVisibleTitle = title
      this.dialogVisible = true
      this.isdisabled = false
      this.getOrg()
      if (title == "查看") {
        this.formData = {
          id: row.id,
          ensure: Number(row.ensure),
          price: row.price,
          userType: Number(row.userType),
          serveStation: Number(row.serveStation),
          servestationName: row.servestationName,
          palnTimeStart: row.palnTimeStart,
          palnTimeEnd: row.palnTimeEnd,
          monthPgdCount: row.monthPgdCount,
          serviceAreaId: String(row.serviceAreaId),
          serviceAreaName: row.serviceAreaName,
          intervalDays: row.intervalDays,
          batch: row.batch,
          pgdName: row.pgdName,
        }
        this.getMeatName()
      } else {
        this.formData = {
          ensure: "",
          price: 0,
          userType: "",
          serveStation: "",
          servestationName: "",
          serviceAreaId: "",
          serviceAreaName: "",
          palnTimeStart: "",
          palnTimeEnd: "",
          monthPgdCount: null,
          intervalDays: null,
        }
      }
    },

    getMeatName() {
      request({
        url: "/jjyl/admin/meal/info/findById",
        method: "POST",
        data: {
          id: this.formData.ensure,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.formData.ensureNames = res.content.mealType
        }
      })
    },
    // // 获取批次
    // getBath(id) {

    // },
    //table表格表单弹窗关闭时事件
    dialogVisibleClose() {
      this.formButtonType = "工单预设服务"
      this.dialogVisible = false
      this.$refs.formData.resetFields()
      this.formData = {
        ensure: "",
        price: 0,
        userType: "",
        serveStation: "",
        servestationName: "",
        serviceAreaId: "",
        serviceAreaName: "",
        palnTimeStart: "",
        palnTimeEnd: "",
        monthPgdCount: null,
        intervalDays: null,
      }
    },
    //清空搜索条件
    emptySearch() {
      this.pageSize = 10
      this.pageNo = 1
      this.showList()
    },
    querySearch() {
      this.pageNo = 1
      this.showList()
    },
    //获取表格数据
    showList() {
      const self = this
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        userType: this.userType,
        ensure: this.ensure,
        serveStation: this.serveStation,
      }
      this.$http
        .request({
          url: "/jjyl/servicePgd/plan/info/findPlanPgdList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              this.total = 0
              return
            }
            let nowDate = new Date().getTime()
            res.content.list.forEach((item) => {
              let endTime = new Date(item.palnTimeEnd).getTime()
              if (endTime < nowDate) {
                item.endPlan = 0
              } else {
                let surplus = Math.ceil(
                  (Number(endTime) - Number(nowDate)) / (60 * 60 * 24 * 1000)
                )
                console.log(
                  surplus,
                  "结束时间",
                  Number(endTime) - Number(nowDate)
                )
                item.endPlan = surplus
              }
              // console.log(item.endPlan, "结束时间")
            })
            this.tableData = res.content.list
            if (this.saveIds.length > 0) {
              self.tableData.forEach((item, index) => {
                self.saveIds.forEach((it) => {
                  if (item.id == it) {
                    self.$refs.tables.toggleRowSelection(
                      self.tableData[index],
                      true
                    )
                  }
                })
              })
            }

            this.total = res.content.count
          }
        })
    },
    // 点击用户类型传递参数
    oldType(e) {
      this.typeParameter = e
    },
    //新增项目保存
    save() {
      this.isdisabled = true
      this.$refs.formData.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          })
          let url = "/jjyl/servicePgd/plan/info/addPlan"
          let parmar = this.formData
          request({
            url,
            method: "POST",
            data: parmar,
          })
            .then((res) => {
              this.isdisabled = false
              if (res.code == 200) {
                loading.close()
                this.showList()
                this.dialogVisible = false
              } else {
                loading.close()
                this.$message.error(res.message)
              }
              //
            })
            .catch((error) => {
              this.dialogVisible = false
              loading.close()
            })
        } else {
          this.isdisabled = false
          return false
        }
      })
    },

    //删除表格信息
    deleteItem(date) {
      let params = {
        id: date.id,
      }
      params = Object.assign({}, params)
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/jjyl/admin/projectManage/info/deleteById",
          method: "POST",
          data: params,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功")
            this.showList()
          }
        })
      })
    },

    // 页面刷新
    Reset() {
      this.reload()
    },
    //获取用户类型
    getusertypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "usertype",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.customerTypeList = res.rows
            }
          }
        })
    },
  },
  inject: ["reload"], //注入
  created() {
    this.getusertypeList()
    this.showList()
    this.getMeat()
  },
}
</script>

<style lang="less" scoped>
.table_container {
  width: 100%;
}

.fixed {
  position: absolute;
  right: 20px;
  top: 90px;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 100%;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 290px;
    line-height: 290px;
    text-align: center;
  }

  .avatar {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 290px;
    line-height: 290px;

    img {
      width: 100%;
      height: 290px;
      line-height: 290px;
      display: block;
    }
  }
}

.service-order-list {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;

  .service-order-item {
    width: 33%;
    text-align: center;
    background-color: rgb(215, 215, 215);

    .service-order-num {
      height: 60px;
      line-height: 60px;
      font-weight: 600;
      font-size: 22px;
    }

    .service-order-title {
      height: 40px;
      line-height: 40px;
      font-weight: 600;
      font-size: 18px;
    }
  }
}
/deep/.hui {
  color: #999;
}
.labelImportBtn {
  margin: 0 10px;

  span {
    width: 70px;
    height: 40px;
    text-align: center;
    display: inline-block;
    line-height: 40px;
    font-size: 14px;
    background-color: #409eff;
    cursor: pointer;
    color: #ffffff;
    border-radius: 5px;
  }
}
.button1 {
  margin-left: 15px;
}
.endPlanBox {
  text-align: center;
  position: absolute;
  left: 0;
  width: 100%;
  top: 0;
  height: 100%;
  text-align: center;
  line-height: 40px;
  span {
    position: relative;
    font-size: 12px;
  }
  .endRed {
    color: #ff2e2e;
    font-size: 14px;
  }
  .endOrange {
    color: #ff862c;
    font-size: 14px;
  }
  .endGreen {
    color: #1bd111;
    font-size: 14px;
  }
  img {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    width: 40px;
    height: 40px;
  }
}
</style>
